<template>
	<div class="owl-carousel">
		<!-- <pre>{{data}}</pre> -->
		<template v-for='(item, i) in items'>
			<div class="item" :data-item-id="`${i}`">
				<div class="imgContainer"
					v-for='(itm, j) in item.slide'
						:class="j == 0 ? 'active' : ''"
						:style="`background-image: url('${itm.src}')`"
						:data-id='`${i}-${j}`'
					>
				</div>
				<div class="bottomBar" v-if="item.slide[0].color">
					<div class="container">
						<p>{{data.button_text}}</p>
						<div class="colorChoice">
							<div class="color" v-for="(itm, j) in item.slide"
							:class="j == 0 ? 'active' : ''"
							:style="`background-color: ${itm.color};`"
							@click="change($event, itm.color, `${i}-${j}`)"
							v-if="itm.color"
							>
						</div>
					</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
module.exports = {

	props: ['data'],

	data () {
		return {
			src: ''
		}
	},

	computed: {
		items() {
			return this.data ? this.data.items : [];
		}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: false,
				// loop: false,
				nav: true,
				dots: true,
				onInitialized: function () {
					let data_param = $('.slider-product-slider').find('.owl-item.active').find('.item').attr('data-item-id');
					$(document).trigger('pstanslate', [data_param]);
				},
				onTranslated: function () {
					let data_param = $('.slider-product-slider').find('.owl-item.active').find('.item').attr('data-item-id');
					console.log($('.slider-product-slider').find('.owl-item.active').find('.item').attr('data-item-id'));
					$(document).trigger('pstanslate', [data_param]);
				}
			}
		});
	},

	methods: {
		change(e, color, id) {

			// console.log(e.target);
			// console.log(color, id);

			$(e.target).closest('.colorChoice').find('.color').removeClass('active');
			$(e.target).addClass('active');

			$(e.target).closest('.item').find('.imgContainer').removeClass('active');
			$(`[data-id="${id}"]`).addClass('active');
		}
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
$height: 250px;

.global-slider-container {
	.slider-product-slider {
		height: $height;
		position: relative;
		margin-bottom: 50px;
		@include m_up{
			height: 514px;
		};

		.owl-carousel {

			.item {
				height: $height;
				background-position: center;
				background-size: cover;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative!important;
				@include m_up{
					height: 514px;
				};
				.imgContainer{
					position: absolute;
					top: 0;
					left: 0;
					height: $height;
					border-radius: 5px;
					opacity: 0;
					background-size: contain;
					background-position: center;
					@include single-transition();
					@include m_up{
						height: 514px;
					};
					&.active{
						opacity: 1;
					}
				}
				.bottomBar{
					position: absolute;
					bottom: 30px;
					left: 0;
					right: 0;
					z-index: 2;
					display: none;
					margin: auto;
					width: 100%!important;
					justify-content: center;
					align-items: center;
					@include m_up{
						display: flex;
					};
					.container{
						display: flex;
						background-color: white;
						border-radius: 22px;
						padding: 0 30px;
						height: 52px;
						align-items: center;
						box-shadow: 5px 5px 10px rgba(0,0,0,.1);
					}
					.colorChoice{
						padding-left: 15px;
						display: flex;
						align-items: center;
						.color{
							width: 20px;
							height: 20px;
							margin: 0 5px;
							border-radius: 100%;
							position: relative;
							@include single-transition();
							cursor: pointer;
							&:before{
								position: absolute;
								top: 3px;
								left: 3px;
								background-color: white;
								width: 14px;
								height: 14px;
								content: "";
								border-radius: 100px;
								@include single-transition();
							}
							&:hover, &.active{
								transform: translateY(-3px);
								box-shadow: 0px 3px 5px rgba(0,0,0,.20);
								&:before{
									opacity: 0;
								}
							}
						}
					}
				}
			}
		}

		.owl-nav {
			height: 50px;
			// background-color: rgba(red, .1);
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 10px;
			@include l__up{
				margin-top: 0;
			};

			.owl-prev, .owl-next {
				width: 32px;
				height: 32px;
				font-size: 0;
				background: url('#{$imgPathSCSS}ps1-prev.png') no-repeat center;
				background-size: 100% 100%;
				@include single-transition;
				@include m_up {
					width: 44px;
					height: 44px;
				}
				@include l__up {
					width: 50px;
					height: 50px;
					position: absolute;
					top: calc(50% - 25px);
				};
				@include l___up {
					width: 56px;
					height: 56px;
					top: calc(50% - 23px);
				};

				&:hover {
					background-image: url('#{$imgPathSCSS}ps1-prev-a.png');
				}
			}

			.owl-prev {
				@include m___up {
					left: -70px;
				};
			}

			.owl-next {
				@include rotate(180deg);
				@include m___up {
					right: -70px;
				};
			}
		}

		.owl-dots {
			position: absolute;
			left: 50px;
			right: 50px;
			bottom: -60px;
			height: 50px;
			// background-color: rgba(green, .1);
			display: flex;
			justify-content: center;
			align-items: center;
			// @include pointer-events(none);
			touch-action: manipulation;
			@include l__up{
				bottom: -50px;
			};

			.owl-dot {
				border: 2px solid #BABABD;
				position: relative;
				border-radius: 100%;
				opacity: .5;
				width: 12px;
				height: 12px;
				margin: 0 4px;
				@include single-transition;
				@include m__up {
					width: 18px;
					height: 18px;
					margin: 0 7px;
				};

				&.active {
					opacity: 1;
					&:after {
						opacity: 1;
					}
				}

				&:after {
					content: '';
					display: block;
					background-color: #BABABD;
					position: absolute;
					border-radius: 100%;
					opacity: 0;
					@include single-transition;
					width: 4px;
					height: 4px;
					top: calc(50% - 2px);
					left: calc(50% - 2px);
					@include m__up {
						width: 6px;
						height: 6px;
						top: calc(50% - 3px);
						left: calc(50% - 3px);
					};
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// product_slider.vue?4ab74040